'use client';

import React from 'react';
import Link from 'next/link';
import MatrixGrid from '@/app/components/MatrixGrid';
import { Settings } from 'lucide-react';
import { socials } from '@/types/socials';

export default function MaintenanceScreen() {
    return (
        <div className="min-h-screen text-green-400 overflow-hidden relative">
            <MatrixGrid />
            <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 text-center">
                <div className="backdrop-blur rounded-xl px-8 py-12 md:px-16 shadow-lg shadow-emerald-500/10 max-w-3xl w-full">
                    <div className="flex justify-center mb-6">
                        <Settings
                            className="w-14 h-14 md:w-16 md:h-16 text-green-400 animate-[spin_6s_linear_infinite] drop-shadow-[0_0_12px_rgba(74,222,128,0.45)]"
                            strokeWidth={1.5}
                        />
                    </div>

                    <h1 className="text-3xl md:text-5xl font-mono font-bold tracking-widest mb-4">
                        <span className="bg-gradient-to-r from-green-400 via-emerald-300 to-green-500 bg-clip-text text-transparent">
                            UNDER MAINTENANCE
                        </span>
                    </h1>

                    <p className="text-green-300 font-mono text-sm md:text-base mb-6">
                        <span className="inline-block animate-pulse">{'['}</span>
                        {' '}WE&apos;LL BE BACK SOON{' '}
                        <span className="inline-block animate-pulse">{']'}</span>
                    </p>

                    <p className="text-green-400/70 font-mono text-xs md:text-sm leading-relaxed">
                        We&apos;re currently performing scheduled maintenance to improve your experience.
                        We apologize for any inconvenience and appreciate your patience.
                    </p>

                    {/* Socials */}
                    <div className="flex flex-wrap justify-center gap-2 mt-8">
                        {socials.map((social, index) => {
                            const Icon = social.icon;
                            return (
                                <Link
                                    key={index}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={social.name}
                                    title={social.name}
                                    className={`w-9 h-9 flex items-center justify-center rounded-lg text-gray-400 transition-all duration-200 hover:bg-white/5 hover:-translate-y-0.5 ${social.color}`}
                                >
                                    <Icon className="w-4 h-4" />
                                </Link>
                            );
                        })}
                    </div>

                    {/* Contact */}
                    <p className="mt-4 text-xs font-mono text-gray-400">
                        Business Inquiries:{' '}
                        <Link
                            href="mailto:sokolovasrimtautasmatas@gmail.com"
                            className="text-green-400 hover:text-green-300 underline underline-offset-2 transition-colors duration-200 break-all"
                        >
                            sokolovasrimtautasmatas@gmail.com
                        </Link>
                    </p>

                    <div className="mt-8 h-1 w-full bg-gradient-to-r from-transparent via-green-400 to-transparent animate-pulse rounded-full" />
                </div>
            </div>
        </div>
    );
}